import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FiX } from "react-icons/fi";
import Portal from "../Portal";

function Modal({ open = false, children, onClose = () => {}, className = "", contentClass = "", zIndex = "z-50", title = "", showCloseButton = true }) {
	const canClose = typeof onClose === "function";
	const showClose = showCloseButton && canClose;

	return (
		<Portal>
			<Transition.Root show={open ? true : false} as={Fragment}>
				<Dialog open={open ? true : false} as="div" className={`relative ${zIndex} dialog`} onClose={() => onClose()}>
					<Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
						<div className="backdrop" />
					</Transition.Child>
					<div className={`fixed inset-0 overflow-y-auto z-10 ${className}`}>
						<div className="flex items-center justify-center min-h-full p-4 text-center">
							<Transition.Child
								as={Fragment}
								enter="ease-out duration-300"
								enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
								enterTo="opacity-100 translate-y-0 sm:scale-100"
								leave="ease-in duration-200"
								leaveFrom="opacity-100 translate-y-0 sm:scale-100"
								leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							>
								<Dialog.Panel className={`content relative ${contentClass}`}>
									{showClose && (
										<button
											type="button"
											onClick={() => onClose()}
											className="absolute top-3 right-3 p-1.5 rounded-md text-secondary hover:text-dark hover:bg-canvas focus:outline-none focus:ring-2 focus:ring-primary z-[1]"
											aria-label="Close"
										>
											<FiX className="w-5 h-5" aria-hidden="true" />
										</button>
									)}
									{title ? (
										<div className="pr-10 pb-2">
											<Dialog.Title as="h2" className="text-lg font-semibold text-dark">
												{title}
											</Dialog.Title>
										</div>
									) : null}
									{children}
								</Dialog.Panel>
							</Transition.Child>
						</div>
					</div>
				</Dialog>
			</Transition.Root>
		</Portal>
	);
}

export default Modal;
